import { useIntl } from 'react-intl';
import { config } from './config';

const useLocalizedDateFormat = () => {
  const { formatMessage } = useIntl();

  const localizedDateFormat = config.formats.date.replace(/[YMD]/g, char =>
    formatMessage({ id: `address.dateFormatParts.${char.toLowerCase()}` })
  );

  return localizedDateFormat;
};

export default useLocalizedDateFormat;
